import { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useSwitchedPath, useLanguage, LanguageNavLink, LanguageLink } from '@hilma/netina2all';

import { useI18n, useSettings, useTranslate } from '../../hooks';
import { Button } from '../../components';
import { routes } from '../../constants';

interface TopbarProps {
	currentPath: string
}

const TopbarDesktop: React.FC<TopbarProps> = () => {
	const switchedPath = useSwitchedPath();
	const translate = useTranslate()
	const alts = useI18n(i18n => i18n.alts);
	const topbar = useI18n(i18n => i18n.topbar);
	const location = useLocation()
	const classes = useStyles();
	const { showPurchaseButton } = useSettings();
	const purchaseButton = useMemo(() => location.pathname.split('/')[2] !== 'purchase' && location.pathname.split('/')[2] !== 'leave-details', [location.pathname])
	const language = useLanguage()
	const isMobile = useMediaQuery('(pointer:none), (pointer:coarse), screen and (max-width: 67rem)');

	return (
		<>
			<LanguageLink to='/'>
				<img src='/lulav-icons/logo.svg' alt={alts.latetLogo} />
			</LanguageLink>
			{[...routes].slice(1).map(([path, name]) => (
				<LanguageNavLink
					key={path}
					to={path}
					style={!isMobile && language === 'en' ? { margin: '0 0.5vw', fontSize: '1.07rem' } : {}}
					activeClassName="bold"
				>
					{translate(name)}
				</LanguageNavLink>
			))}
			<div className='flex-empty-space'></div>
			<Link to={switchedPath}>
				<div className='lng'>{topbar.otherLang}</div>
			</Link>
			{purchaseButton ?
				<Button to={showPurchaseButton ? '/purchase' : '/leave-details'} className={classes.button}>{topbar.buy}</Button>
				: <></>}
		</>
	);
}

export default TopbarDesktop;

const useStyles = makeStyles({
	button: {
		padding: '0.2rem 2.7rem !important'
	}
});